module.exports = __webpack_public_path__ + "img/android-tv.01027eb1.svg";